// Client API — wrapper attorno a fetch verso gli endpoint PHP.
// Tutte le richieste inviano il cookie di sessione con credentials: 'include'.

const BASE = "/api";

async function apiRequest(path, { method = "GET", body, headers, isMultipart = false } = {}) {
  const opts = {
    method,
    credentials: "include",
    headers: {
      Accept: "application/json",
      ...(isMultipart ? {} : { "Content-Type": "application/json" }),
      ...(headers || {}),
    },
  };

  if (body !== undefined) {
    opts.body = isMultipart ? body : JSON.stringify(body);
  }

  const res = await fetch(`${BASE}${path}`, opts);
  const contentType = res.headers.get("content-type") || "";
  const isJson = contentType.includes("application/json");
  const data = isJson ? await res.json() : await res.text();

  if (!res.ok) {
    const message = (data && data.error) || `Errore ${res.status}`;
    const err = new Error(message);
    err.status = res.status;
    err.data = data;
    throw err;
  }

  // Se la risposta non è JSON, l'endpoint non ha funzionato come atteso
  // (es. dev server locale che serve index.html per /api/*).
  if (!isJson) {
    const err = new Error(`Risposta non-JSON da ${path} (probabilmente endpoint non raggiungibile)`);
    err.status = res.status;
    throw err;
  }

  return data;
}

// Auth
export const login = (email, password) =>
  apiRequest("/login.php", { method: "POST", body: { email, password } });

export const logout = () => apiRequest("/logout.php", { method: "POST" });

export const getMe = () => apiRequest("/me.php");

// Progetti
export const listProgetti = () => apiRequest("/progetti.php");
export const getProgetto = (id) => apiRequest(`/progetti.php?id=${id}`);
export const createProgetto = (data) =>
  apiRequest("/progetti.php", { method: "POST", body: data });
export const updateProgetto = (id, data) =>
  apiRequest(`/progetti.php?id=${id}`, { method: "PUT", body: data });
export const deleteProgetto = (id) =>
  apiRequest(`/progetti.php?id=${id}`, { method: "DELETE" });

// Testimonianze
export const listTestimonianze = () => apiRequest("/testimonianze.php");
export const createTestimonianza = (data) =>
  apiRequest("/testimonianze.php", { method: "POST", body: data });
export const updateTestimonianza = (id, data) =>
  apiRequest(`/testimonianze.php?id=${id}`, { method: "PUT", body: data });
export const deleteTestimonianza = (id) =>
  apiRequest(`/testimonianze.php?id=${id}`, { method: "DELETE" });

// Form pubblici
export const submitPreventivo = (data) =>
  apiRequest("/preventivo.php", { method: "POST", body: data });

export const submitContatto = (data) =>
  apiRequest("/contatto.php", { method: "POST", body: data });

// Submissions admin
export const listSubmissions = (params = {}) => {
  const q = new URLSearchParams();
  if (params.tipo) q.set("tipo", params.tipo);
  if (params.unread) q.set("unread", "1");
  const qs = q.toString();
  return apiRequest(`/submissions.php${qs ? "?" + qs : ""}`);
};

export const markSubmissionRead = (id, isRead) =>
  apiRequest(`/submissions.php?id=${id}`, { method: "PATCH", body: { is_read: isRead } });

export const deleteSubmission = (id) =>
  apiRequest(`/submissions.php?id=${id}`, { method: "DELETE" });

// Upload
export const uploadImage = async (file) => {
  const form = new FormData();
  form.append("file", file);
  form.append("kind", "image");
  return apiRequest("/upload.php", { method: "POST", body: form, isMultipart: true });
};

// Upload generico (immagine, PDF o video): il server rileva il tipo dal MIME.
export const uploadFile = (file) => {
  const form = new FormData();
  form.append("file", file);
  return apiRequest("/upload.php", { method: "POST", body: form, isMultipart: true });
};

// Libreria media (file già caricati)
export const listMedia = ({ kind } = {}) =>
  apiRequest(`/media.php${kind ? "?kind=" + encodeURIComponent(kind) : ""}`);

export const deleteMedia = (id) =>
  apiRequest(`/media.php?id=${id}`, { method: "DELETE" });
